import { baseRestApi } from "api/rest/baseRestApi";
import {
  ExportReportCsvApi,
  GetCsvForDownloadApi,
  GetReportApi,
  ListReportTypesApi,
} from "app/pages/reports-and-analytics/api/api-types";
import {
  transformExportReportCsvResponse,
  transformGetCsvForDownloadResponse,
  transformGetReportResponse,
  transformListReportTypesResponse,
} from "app/pages/reports-and-analytics/api/mappers";
import enhanceWithPagination from "utils/enhanceWithPagination";

export const API_ROOT = "/broker/insights";

// For the time being the broker reports api is identical to the shipper api
// So we will reuse the typings and mappers even though they're the old way of doing it
const brokerInsightsApi = baseRestApi.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",

  endpoints: (builder) => ({
    getBrokerReportTypeList: builder.query<ListReportTypesApi["hookReturnValue"], {}>({
      query: () => ({
        url: `${API_ROOT}/reports`,
        method: "GET",
      }),
      transformResponse: transformListReportTypesResponse,
    }),

    getBrokerReport: builder.query<GetReportApi["hookReturnValue"], GetReportApi["queryArgs"]>({
      query: ({ urlParams: { id }, queryParams }) => ({
        url: `${API_ROOT}/reports/${id}`,
        method: "GET",
        params: queryParams,
      }),
      transformResponse: transformGetReportResponse,
    }),

    exportBrokerReportCsv: builder.mutation<ExportReportCsvApi["hookReturnValue"], ExportReportCsvApi["queryArgs"]>({
      query: ({ urlParams: { reportId }, queryParams }) => ({
        url: `${API_ROOT}/reports/${reportId}/export`,
        method: "POST",
        params: queryParams,
      }),
      transformResponse: transformExportReportCsvResponse,
    }),

    getBrokerCsvForDownload: builder.query<GetCsvForDownloadApi["hookReturnValue"], GetCsvForDownloadApi["queryArgs"]>({
      query: ({ urlParams: { jobId, reportId } }) => ({
        url: `${API_ROOT}/reports/${reportId}/export/${jobId}`,
        method: "GET",
      }),
      transformResponse: transformGetCsvForDownloadResponse,
    }),
  }),
});

export default brokerInsightsApi;

export const { useGetBrokerReportTypeListQuery, useExportBrokerReportCsvMutation, useGetBrokerCsvForDownloadQuery } =
  brokerInsightsApi;

export const { useGetBrokerReportQuery } = enhanceWithPagination(brokerInsightsApi, "getBrokerReport");
